import React from 'react';

export const EmptyData = (
  <svg viewBox='0 0 96 132' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_414_384)'>
      <path
        d='M90.7083 117.632H21.6793C19.0531 117.632 16.916 115.488 16.916 112.852V14.3943C16.916 11.7585 19.0531 9.61359 21.6793 9.61359H90.7083C93.3346 9.61359 95.4716 11.7585 95.4716 14.3943V112.877C95.4716 115.488 93.3346 117.632 90.7083 117.632Z'
        fill='#3B3F51'
      />
      <path
        d='M90.245 109.931H75.8264H21.9626V13.2054H90.245V97.8891V109.931Z'
        fill='white'
        stroke='#3B3F51'
        strokeWidth='1.4109'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M65.7072 6.2797H63.3127L64.2139 1.03381H47.9672L48.9971 6.2797H46.8601C44.2081 6.2797 42.071 8.42457 42.071 11.0863V15.9962H70.2903V10.8795C70.2903 8.32121 68.2305 6.2797 65.7072 6.2797Z'
        fill='white'
      />
      <path
        d='M71.3207 14.9369H43.1272V10.027C43.1272 7.36527 45.2642 5.2204 47.9162 5.2204H66.7634C69.2866 5.2204 71.3464 7.28774 71.3464 9.82024V14.9369H71.3207Z'
        fill='#24BB72'
      />
      <path d='M50.0275 5.24589L48.9976 0H65.2442L64.3431 5.24589H50.0275Z' fill='#24BB72' />
      <path
        d='M65.7072 6.2797H63.3127L64.2139 1.03381H47.9672L48.9971 6.2797H46.8601C44.2081 6.2797 42.071 8.42457 42.071 11.0863V15.9962H70.2903V10.8795C70.2903 8.32121 68.2305 6.2797 65.7072 6.2797Z'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M40.5267 39.77H28.9146V28.1153H40.5267V39.77ZM29.2493 39.4599H40.2177V28.4512H29.2493V39.4599Z'
        fill='#24BB72'
      />
      <path
        d='M81.5423 30.9324C81.5423 30.9841 73.4576 31.01 63.4933 31.01C53.529 31.01 45.4443 30.9841 45.4443 30.9324C45.4443 30.8808 53.529 30.8549 63.4933 30.8549C73.4576 30.8549 81.5423 30.8808 81.5423 30.9324Z'
        fill='#3B3F51'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M81.5423 33.3613C81.5423 33.413 73.4576 33.4389 63.4933 33.4389C53.529 33.4389 45.4443 33.413 45.4443 33.3613C45.4443 33.3097 53.529 33.2838 63.4933 33.2838C73.4576 33.2838 81.5423 33.3097 81.5423 33.3613Z'
        fill='#3B3F51'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M81.5423 35.7907C81.5423 35.8424 73.4576 35.8682 63.4933 35.8682C53.529 35.8682 45.4443 35.8424 45.4443 35.7907C45.4443 35.739 53.529 35.7132 63.4933 35.7132C73.4576 35.6873 81.5423 35.739 81.5423 35.7907Z'
        fill='#3B3F51'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M81.5423 38.1941C81.5423 38.2458 73.4576 38.2716 63.4933 38.2716C53.529 38.2716 45.4443 38.2458 45.4443 38.1941C45.4443 38.1424 53.529 38.1166 63.4933 38.1166C73.4576 38.1166 81.5423 38.1683 81.5423 38.1941Z'
        fill='#3B3F51'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M40.5267 57.7302H28.9146V46.0755H40.5267V57.7302ZM29.2493 57.3942H40.2177V46.3856H29.2493V57.3942Z'
        fill='#24BB72'
      />
      <path
        d='M31.2319 52.1492L32.7768 50.4953L35.3515 52.5368L41.222 46.8257L42.6381 48.4796L35.2228 55.8187L31.2319 52.1492Z'
        fill='#24BB72'
      />
      <path
        d='M81.5423 48.8923C81.5423 48.944 73.4576 48.9699 63.4933 48.9699C53.529 48.9699 45.4443 48.944 45.4443 48.8923C45.4443 48.8407 53.529 48.8148 63.4933 48.8148C73.4576 48.8148 81.5423 48.8407 81.5423 48.8923Z'
        fill='#3B3F51'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M81.5423 51.3215C81.5423 51.3732 73.4576 51.3991 63.4933 51.3991C53.529 51.3991 45.4443 51.3732 45.4443 51.3215C45.4443 51.2699 53.529 51.244 63.4933 51.244C73.4576 51.244 81.5423 51.2699 81.5423 51.3215Z'
        fill='#3B3F51'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M81.5423 53.7254C81.5423 53.7771 73.4576 53.8029 63.4933 53.8029C53.529 53.8029 45.4443 53.7771 45.4443 53.7254C45.4443 53.6737 53.529 53.6479 63.4933 53.6479C73.4576 53.6479 81.5423 53.6996 81.5423 53.7254Z'
        fill='#3B3F51'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M81.5423 56.1543C81.5423 56.206 73.4576 56.2318 63.4933 56.2318C53.529 56.2318 45.4443 56.206 45.4443 56.1543C45.4443 56.1026 53.529 56.0768 63.4933 56.0768C73.4576 56.0768 81.5423 56.1026 81.5423 56.1543Z'
        fill='#3B3F51'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M40.5267 75.0964H28.9146V63.4417H40.5267V75.0964ZM29.2493 74.7863H40.2177V63.7777H29.2493V74.7863Z'
        fill='#24BB72'
      />
      <path
        d='M31.2319 69.5143L32.7768 67.8605L35.3515 69.9278L41.222 64.1909L42.6381 65.8706L35.2228 73.1839L31.2319 69.5143Z'
        fill='#24BB72'
      />
      <path
        d='M81.5423 66.2586C81.5423 66.3102 73.4576 66.3361 63.4933 66.3361C53.529 66.3361 45.4443 66.3102 45.4443 66.2586C45.4443 66.2069 53.529 66.181 63.4933 66.181C73.4576 66.181 81.5423 66.2327 81.5423 66.2586Z'
        fill='#3B3F51'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M81.5423 68.6874C81.5423 68.7391 73.4576 68.765 63.4933 68.765C53.529 68.765 45.4443 68.7391 45.4443 68.6874C45.4443 68.6358 53.529 68.6099 63.4933 68.6099C73.4576 68.6099 81.5423 68.6358 81.5423 68.6874Z'
        fill='#3B3F51'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M81.5423 71.1163C81.5423 71.168 73.4576 71.1939 63.4933 71.1939C53.529 71.1939 45.4443 71.168 45.4443 71.1163C45.4443 71.0647 53.529 71.0388 63.4933 71.0388C73.4576 71.0388 81.5423 71.0647 81.5423 71.1163Z'
        fill='#3B3F51'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M81.5423 73.5457C81.5423 73.5973 73.4576 73.6232 63.4933 73.6232C53.529 73.6232 45.4443 73.5973 45.4443 73.5457C45.4443 73.494 53.529 73.4681 63.4933 73.4681C73.4576 73.4423 81.5423 73.494 81.5423 73.5457Z'
        fill='#3B3F51'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M40.5267 91.8937H28.9146V80.239H40.5267V91.8937ZM29.2493 91.5577H40.2177V80.5491H29.2493V91.5577Z'
        fill='#24BB72'
      />
      <path
        d='M31.2319 86.2855L32.7768 84.6316L35.3515 86.699L41.222 80.9621L42.6381 82.6418L35.2228 89.9551L31.2319 86.2855Z'
        fill='#24BB72'
      />
      <path
        d='M81.5423 83.0552C81.5423 83.1069 73.4576 83.1327 63.4933 83.1327C53.529 83.1327 45.4443 83.1069 45.4443 83.0552C45.4443 83.0035 53.529 82.9777 63.4933 82.9777C73.4576 82.9519 81.5423 83.0035 81.5423 83.0552Z'
        fill='#3B3F51'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M81.5423 85.4586C81.5423 85.5103 73.4576 85.5361 63.4933 85.5361C53.529 85.5361 45.4443 85.5103 45.4443 85.4586C45.4443 85.4069 53.529 85.3811 63.4933 85.3811C73.4576 85.3811 81.5423 85.4328 81.5423 85.4586Z'
        fill='#3B3F51'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M81.5423 87.8875C81.5423 87.9392 73.4576 87.965 63.4933 87.965C53.529 87.965 45.4443 87.9392 45.4443 87.8875C45.4443 87.8358 53.529 87.81 63.4933 87.81C73.4576 87.81 81.5423 87.8358 81.5423 87.8875Z'
        fill='#3B3F51'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M81.5423 90.3169C81.5423 90.3686 73.4576 90.3944 63.4933 90.3944C53.529 90.3944 45.4443 90.3686 45.4443 90.3169C45.4443 90.2652 53.529 90.2394 63.4933 90.2394C73.4576 90.2135 81.5423 90.2652 81.5423 90.3169Z'
        fill='#3B3F51'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M15.5258 56.2317C17.1737 56.3609 18.5898 55.0947 18.667 53.415C18.7185 51.8128 18.77 50.2106 18.77 50.2106C18.77 50.2106 21.1645 49.978 21.3448 47.6006C21.525 45.2231 21.4478 39.693 21.4478 39.693C18.77 38.3233 15.5516 38.5301 13.0798 40.2356L13.2343 48.6342V53.1566C13.2343 54.7071 14.0067 56.1284 15.5258 56.2317Z'
        fill='white'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M18.9758 44.706C18.5638 44.1892 17.8944 43.9824 17.3537 44.3442C16.813 44.706 16.607 45.5071 16.8902 46.0756C17.0962 46.4891 17.5854 46.8509 18.0489 46.9543C18.4866 47.0576 18.8213 47.4711 18.7698 47.9362C18.6925 48.5306 18.3836 49.0991 17.9459 49.5901C17.2507 50.3654 16.2208 50.7788 15.1909 50.9081C14.1867 51.0373 13.0281 50.8047 12.4359 49.9777C11.9982 49.3575 11.9724 48.5823 11.9724 47.8329C11.9467 46.0756 11.8952 44.3184 11.8695 42.5611C11.8437 41.9151 11.8437 41.2949 11.9982 40.6747C12.1527 40.0545 12.4616 39.4601 13.0023 39.0983C13.5688 38.7107 14.3155 38.6849 14.9849 38.4781C15.8088 38.2197 16.504 37.6512 17.2764 37.2636C18.0489 36.8759 19.0015 36.6434 19.7739 37.031C20.3404 37.3153 20.7008 37.8579 21.2415 38.168C22.014 38.6073 23.0696 38.504 23.4301 39.641C23.5588 40.0286 23.5588 40.468 23.4301 40.8556C22.9151 42.4061 21.0098 43.0263 19.6194 42.3544C19.5937 42.6128 19.8512 43.2072 19.568 44.0341C19.4135 44.2925 19.3877 44.706 18.9758 44.706Z'
        fill='#1F222B'
      />
      <path
        d='M12.4101 39.7962C12.7448 39.0209 13.0795 38.2457 13.1825 37.3929C13.2597 36.5659 13.0538 35.6356 12.4358 35.0671C12.0239 34.6795 11.4317 34.4986 10.8652 34.4986C9.78382 34.5244 8.77967 35.3514 8.4707 36.4109C8.16173 37.4704 8.57369 38.6591 9.42336 39.3569C10.273 40.0288 11.5089 40.1838 12.5131 39.7703'
        fill='#1F222B'
      />
      <path
        d='M12.8734 38.9172C12.9249 38.9172 12.8734 39.3307 12.5129 39.6925C12.1524 40.0542 11.7405 40.0801 11.7405 40.0284C11.7405 39.9767 12.1009 39.8734 12.4099 39.5632C12.7189 39.2531 12.8219 38.8914 12.8734 38.9172Z'
        fill='#24BB72'
      />
      <path
        d='M6.90039 62.2527C6.90039 62.2527 5.69025 71.1681 6.90039 72.3051C8.11052 73.4422 9.26915 73.0546 9.26915 73.0546L11.5864 71.1164L12.0499 62.2527H6.90039Z'
        fill='white'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M31.978 37.2377L33.5229 35.558L36.0976 37.6253L41.9681 31.8884L43.3842 33.5681L35.9689 40.8814L31.978 37.2377Z'
        fill='#24BB72'
      />
      <path
        d='M39.2131 37.6767L36.9731 39.1238C36.8701 38.2452 36.2007 37.3666 36.2264 37.8059C36.2522 38.2452 36.2264 40.571 36.2264 40.571L32.2355 48.9954C31.6949 50.3392 30.5877 51.1661 29.7638 51.3729L26.0562 52.4841L27.498 57.4199L32.6733 55.6884C34.0121 55.2491 35.0678 54.1896 35.5055 52.8458L39.0586 41.9406C39.0586 41.9406 39.4706 40.7002 39.6251 39.7957C39.8311 38.8654 39.2131 37.6767 39.2131 37.6767Z'
        fill='white'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M20.9066 129.725L20.8551 127.219L16.1948 127.296L16.2463 130.94L16.5295 130.966C17.8169 131.017 23.0694 131.147 23.9191 130.862C24.8717 130.578 20.9066 129.725 20.9066 129.725Z'
        fill='white'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M4.45424 128.924L6.02484 126.986L2.47168 124.014L0.128662 126.805L0.334642 127.012C1.2873 127.891 5.17517 131.431 6.02484 131.767C6.926 132.155 4.45424 128.924 4.45424 128.924Z'
        fill='white'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
      <path
        d='M14.1611 76.6976C14.1611 76.6976 12.6162 83.2873 13.0539 84.5794C13.4916 85.8715 16.3239 86.6467 16.3239 86.6467L16.2209 104.684L0.514893 124.195L6.30808 128.95C6.30808 128.95 23.3272 109.413 24.8205 105.873C26.3139 102.333 23.8679 76.4134 23.8679 76.4134L14.1611 76.6976Z'
        fill='#1F222B'
      />
      <path
        d='M22.1945 74.0106L22.9669 128.795L14.9594 128.847L10.9428 84.2181C10.0932 83.417 8.90878 82.0215 9.06327 78.9205L9.26925 75.3027L22.1945 74.0106Z'
        fill='#1F222B'
      />
      <path
        d='M12.5131 49.8999C11.1999 48.6595 10.4275 46.9023 10.3503 45.0933C10.273 43.2844 10.9425 41.4755 12.1268 40.1317'
        fill='#1F222B'
      />
      <path
        d='M8.00742 55.0168C8.00742 55.0168 6.28234 56.9808 5.92188 64.5266C5.92188 64.5266 10.8654 65.4569 10.9684 65.1985C11.0456 64.9142 8.00742 55.0168 8.00742 55.0168Z'
        fill='#FF4F5B'
      />
      <path
        d='M8.00742 55.0168C8.00742 55.0168 6.28234 56.9808 5.92188 64.5266C5.92188 64.5266 10.8654 65.4569 10.9684 65.1985C11.0456 64.9142 8.00742 55.0168 8.00742 55.0168Z'
        fill='#24BB72'
      />
      <path
        d='M8.8053 76.9573H23.9963L23.7388 74.5798C23.7388 74.5798 22.0138 65.5093 22.0138 65.406L22.297 64.8375C23.0179 63.3128 23.0437 61.5814 22.3742 60.0567L29.8153 57.4984L27.9872 51.348C24.6143 51.9165 19.5163 52.5626 19.5163 52.5626L18.7696 52.6143C18.7696 52.6143 13.5171 52.8985 13.3884 52.8985C11.1741 53.157 8.62507 53.3378 7.69816 55.6895C7.20896 56.9557 7.67241 58.8422 8.49633 60.8061L10.4531 66.8273C11.2256 70.135 9.98969 69.98 9.32025 73.3136C9.16577 73.7787 8.8053 76.4921 8.8053 76.9573Z'
        fill='#24BB72'
      />
      <g opacity='0.3'>
        <path
          opacity='0.3'
          d='M8.8053 76.9573H23.9963L23.7388 74.5798C23.7388 74.5798 22.0138 65.5093 22.0138 65.406L22.297 64.8375C23.0179 63.3128 23.0437 61.5814 22.3742 60.0567L29.8153 57.4984L27.9872 51.348C24.6143 51.9165 19.5163 52.5626 19.5163 52.5626L18.7696 52.6143C18.7696 52.6143 13.5171 52.8985 13.3884 52.8985C11.1741 53.157 8.62507 53.3378 7.69816 55.6895C7.20896 56.9557 7.67241 58.8422 8.49633 60.8061L10.4531 66.8273C11.2256 70.135 9.98969 69.98 9.32025 73.3136C9.16577 73.7787 8.8053 76.4921 8.8053 76.9573Z'
          fill='#24BB72'
        />
      </g>
      <path
        d='M22.0398 65.3799L22.323 64.8114C23.044 63.2867 23.0697 61.5553 22.4003 60.0307L29.8413 57.4723L28.0132 51.322C24.6403 51.8905 19.5423 52.5365 19.5423 52.5365L18.7956 52.5882C18.7956 52.5882 13.5431 52.8725 13.4144 52.8725C11.4319 53.105 9.16608 53.2859 8.05893 55.0173C8.05893 55.0173 6.33385 56.9813 5.97339 64.5271C5.97339 64.5271 8.47089 64.9923 9.9385 65.1732L10.4792 66.8271C11.2516 70.1348 10.0157 69.9798 9.34631 73.3134C9.24332 73.8043 8.88285 76.5177 8.88285 76.9829H24.0739L23.8164 74.6054C23.7649 74.5538 22.0141 65.5091 22.0398 65.3799Z'
        stroke='#3B3F51'
        strokeMiterlimit='10'
        strokeLinejoin='bevel'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_384'>
        <rect width='95.4717' height='132' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
